import Vue from 'vue'
import App from './App.vue'
import initPlugins from './plugins'
import { api } from '@/services/api'

const MobileDetect = require('mobile-detect')

Vue.config.productionTip = false

const app = {
  name: 'root',
  data () {
    return {
      isMobile: (new MobileDetect(window.navigator.userAgent).mobile())
    }
  },
  beforeCreate () {
    api.interceptors.response.use((response) => {
      const { method, url, updateStore } = response.config
      if (method !== 'get') this.APIUpdate(url, updateStore)
      return response
    })
  },
  created () {
    /**
     * @desc Load and mapping Language Labels and mapping if this source update
     * Example when user change or create Label in "Labels Grid"
     */
    this.APIWatch('Labels/GetAllDynamic?select=id,languageID,labelKey,title', response => {
      if (!response.isLoading) {
        this.$store.commit('set', {
          value: response.records.reduce((result, value) => {
            if (result[value.languageID] === undefined) result[value.languageID] = {}
            value.labelKey = value.labelKey.toLowerCase()
            result[value.languageID][value.labelKey] = value
            return result
          }, {}),
          key: 'L10n'
        })
      }
    })
    /**
     * @desc Load site params
     */
    this.APIWatch('GlobalParameters/GetAllDynamic?filter=id==1', response => {
      if (!response.isLoading) {
        let data = response.records[0]
        this.$store.commit('set', { key: 'globalParameters', value: data })
        // TODO SET PAGE TITLE
        window.document.title = `${data.title} : ${data.version}`
      }
    })
  },
  template: '<App />',
  render: h => h(App)
}
const initApp = async _ => {
  /**
   * @desc Init all plugins and modules
   */
  await initPlugins(app)
}

initApp()
  .then(_ => {
    window.app = new Vue(app).$mount('#app')
  })
